module.exports = __webpack_public_path__ + "static/media/Service1.65a3b6c8.svg";